import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import SButton from "components/Common/Button"
import Table from "./Table"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getProductCategory } from "store/actions"
import Skeleton from "react-loading-skeleton"
import Breadcrumb from "components/Common/Breadcrumb"
import { CustomPagination } from "components/Common/Pagination"

export default function MasterCategories() {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useSelector(({ productCategory }) => productCategory)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [count, setCount] = useState(100)

  useEffect(() => {
    setCount(store?.data?.totalPages)
  }, [store?.data])

  const [filter, setFilter] = useState({
    name: "",
  })

  const params = {
    name: filter.name,
    page: pagination.page,
    size: pagination.size,
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    dispatch(getProductCategory({ ...params, page: 0, size: 10 }))
  }

  useEffect(() => {
    dispatch(getProductCategory(params))
  }, [dispatch])

  useEffect(() => {
    dispatch(getProductCategory(params))
  }, [pagination])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"商品カテゴリー"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商品カテゴリ名"}
                  placeholder={""}
                  value={filter.name}
                  type="text"
                  name="name"
                  onChange={e =>
                    setFilter({ ...filter, [e.target.name]: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton onClick={onSearch} className="mx-2 button">
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mt-3">
              <div className="d-flex justify-content-end align-self-end mb-3">
                <SButton
                  className="button"
                  onClick={() =>
                    history.push("/master/product-category/create")
                  }
                >
                  新規追加
                </SButton>
              </div>
              <Col md={12}>
                {store.status === "process" ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <Table
                      page={pagination.page}
                      size={pagination.size}
                      count={count}
                      content={store.data?.content}
                      setParams={setPagination}
                      params={pagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
